// @ts-ignore
import { getField, updateField } from 'vuex-map-fields'
import BranchAPIs from '@/API/branch-api'
import SubscriptionAPIs from '@/API/subscription/subscription-api'

const tempDomain = {
  enabled: null,
  selected: null,
  domainFromName: '',
  domainName: '',
  domainType: 'exist',
  inPendingMode: false,
  inPendingExist: false,
  fetched: false,
}
export default {
  namespaced: true,
  state: tempDomain,
  getters: {
    getField,
  },
  mutations: {
    updateField,
    SET_TEMP_DOMAIN(state: any) {
      state.inPendingMode = false
      state.inPendingExist = false
    },
    SET_FETCHED(state: any) {
      state.fetched = true
    },
  },
  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      context.commit('SET_TEMP_DOMAIN')
      const settings = await BranchAPIs.getDomainSetting(context.rootGetters['branches/currentBranchId'])
      let domainName = ''
      if (settings.subdomain) {
        domainName = settings?.domain ?? ''
        context.commit('updateField', { path: 'selected', value: 'subdomain' })
      }
      const isBrandedDomainPurchased = context.rootGetters['subscription/isBrandedDomainPurchased']
      if (isBrandedDomainPurchased) {
        domainName = settings.subdomain ? '' : (settings?.domain ?? '')
        context.commit('updateField', { path: 'selected', value: 'domain' })
        if (settings?.pending) context.commit('updateField', { path: 'inPendingMode', value: true })
        if (settings?.exist && !domainName) context.commit('updateField', { path: 'inPendingExist', value: true })
      } else if (!domainName) {
        const name = context.rootGetters['auth/user'].restaurant_name ?? ''
        domainName = name.replace(/ /g, '-').toLowerCase()
      }
      context.commit('updateField', { path: 'enabled', value: (settings.domain_enabled === 1) })

      context.commit('updateField', { path: 'domainFromName', value: domainName })
      context.commit('updateField', { path: 'domainName', value: domainName })

      return true
    },
    async CREATE_REQUEST(context: any, payload: any) {
      if (payload.selectedType === 'domain') {
        const data: any = { exist: (payload.domainType === 'exist') }
        if (payload.domainType !== 'exist')data.domain = payload.domainName
        await SubscriptionAPIs.addOnRequest(data).then(() => {
          context.commit('updateField', { path: 'domainName', value: payload.domainName })
          context.commit('updateField', { path: 'domainFromName', value: payload.domainName })
          context.commit('updateField', { path: 'inPendingExist', value: (payload.domainType === 'exist') })
          context.commit('updateField', { path: 'inPendingMode', value: (payload.domainType !== 'exist') })
        })
        return { error: 0 }
      }
      return { error: 1 }
    },
  },
}
